// import React, { useState } from 'react';
// import { Container, Navbar, Nav, Offcanvas } from 'react-bootstrap';
// import { Link } from 'react-router-dom';
// import logo from '../assets/vertexSuiteLogo.png';
// import ProductsData from './NavSection_Dropdown/ProductsData';
// import { CgEnter } from 'react-icons/cg';

// const Header = () => {
//   const [showOffcanvas, setShowOffcanvas] = useState(false);
//   const handleClose = () => setShowOffcanvas(false);
//   const handleShow = () => setShowOffcanvas(true);

//   const navLinks = [
//     { label: 'Solutions', href: '/#solutions' },
//     { label: 'Products', href: '/#products' },
//     { label: 'Industries', href: '/#industries' },
//     { label: 'Resources', href: '/#resources' },
//     { label: 'About Us', href: '/aboutus' },
//     { label: 'Pricing', href: '/#pricing' }
//   ];

//   return (
//     <Navbar
//       expand="lg"
//       bg="white"
//       className="shadow-sm py-2"
//     >
//       <Container
//         fluid
//         className="px-3 px-md-4 d-flex align-items-center justify-content-between"
//         style={{ maxWidth: '88%' }}
//       >
//         {/* Logo + Text */}
//         <div className="d-flex align-items-center gap-0">
//           <img
//             src={logo}
//             alt="Vertex Suite Logo"
//             style={{ height: '70px', width: '70px', objectFit: 'contain' }} 
//           />
//           <div className="lh-1">
//             <div style={{ position: 'relative', top: '12px' }}> 
//               <span
//                 className="fw-semi-bold"
//                 style={{
//                   fontSize: '24px',
//                   fontFamily: 'Poppins',
//                   fontWeight: 600,
//                   background: 'linear-gradient(90deg, #317cbeff 0%, #59C0FB 100%)',
//                   WebkitBackgroundClip: 'text',
//                   backgroundClip: 'text',
//                   color: 'transparent',
//                 }}
//               >
//                 Vertex Suite
//               </span>
//             </div>
//             <br />
//             <small
//               style={{
//                 fontSize: '14.5px',
//                 fontFamily: 'Outfit, sans-serif',
//                 fontWeight: '500',
//                 color: '#646363ff',
//                 paddingLeft: 2,
//                 position: 'relative',
//                 top: '-4px'
//               }}
//             >
//               Innovating Workflows
//             </small>
//           </div>
//         </div>

//         {/* Desktop Nav Links */}
//         <Nav 
//           className="d-none d-lg-flex align-items-center gap-3" 
//           style={{ 
//             marginLeft: '-20px' 
//           }}
//         >
//           {navLinks.map((link) =>
//             link.label === 'Products' ? (
//               <ProductsData key="ProductsMenu" />
//             ) : (
//               <Nav.Item key={link.label} className="mx-3">
//                 <Link
//                   to={link.href}
//                   className="text-dark fw-normal text-decoration-none"
//                   style={{ 
//                     fontFamily: "Poppins", 
//                     fontSize: '18px'
//                   }}
//                 >
//                   {link.label}
//                 </Link>
//               </Nav.Item>
//             )
//           )}
//         </Nav>

//         {/* Buttons */}
//         <div className="d-none d-lg-flex gap-3 align-items-center">
//           <button
//             style={{
//               padding: '8px 20px',
//               border: '2px solid transparent',
//               borderRadius: '8px',
//               backgroundImage:
//                 'linear-gradient(#fff, #fff), linear-gradient(to right, #4FC3FF, #2C2C6F)',
//               backgroundOrigin: 'border-box',
//               backgroundClip: 'padding-box, border-box',
//               color: '#1D1D1B',
//               fontFamily: "Poppins",
//               fontSize: '18px',
//               fontWeight: 600,
//               cursor: 'pointer',
//               lineHeight: 1.2,
//             }}
//           >
//             Try Demo
//           </button>
//         </div>

//         {/* Mobile: Menu Button */}
//         <button
//           className="d-lg-none btn btn-outline-secondary"
//           onClick={handleShow}
//           aria-label="Open menu"
//         >
//           ☰
//         </button>

//         {/* Offcanvas Drawer */}
//         <Offcanvas show={showOffcanvas} onHide={handleClose} placement="end">
//           <Offcanvas.Header closeButton>
//             <Offcanvas.Title style={{ fontFamily: "'Outfit', sans-serif" }}>
//               Menu
//             </Offcanvas.Title>
//           </Offcanvas.Header>
//           <Offcanvas.Body className="p-0">
//             {navLinks.map((link) => (
//               <div
//                 key={link.label}
//                 style={{
//                   borderBottom: '1px solid #ddd',
//                   padding: '16px 20px',
//                   fontFamily: "'Outfit', sans-serif",
//                   fontSize: '16px',
//                 }}
//               >
//                 <Link
//                   to={link.href}
//                   className="text-dark text-decoration-none"
//                   onClick={handleClose}
//                   style={{ fontFamily: "'Outfit', sans-serif", fontSize: '16px' }}
//                 >
//                   {link.label}
//                 </Link>
//               </div>
//             ))}
//           </Offcanvas.Body>
//         </Offcanvas>
//       </Container>
//     </Navbar>
//   );
// };

// export default Header;


// import React, { useState } from 'react';
// import { Container, Navbar, Nav, Offcanvas } from 'react-bootstrap';
// import { Link } from 'react-router-dom';
// import logo from '../assets/vertexSuiteLogo.png';
// import ProductsData from './NavSection_Dropdown/ProductsData';
// import { CgEnter } from 'react-icons/cg';

// const Header = () => {
//   const [showOffcanvas, setShowOffcanvas] = useState(false);
//   const handleClose = () => setShowOffcanvas(false);
//   const handleShow = () => setShowOffcanvas(true);

//   const navLinks = [
//     { label: 'Solutions', href: '/#solutions' },
//     { label: 'Products', href: '/#products' },
//     { label: 'Industries', href: '/#industries' },
//     { label: 'Resources', href: '/#resources' },
//     { label: 'About Us', href: '/aboutus' },
//     { label: 'Pricing', href: '/#pricing' }
//   ];

//   return (
//     <Navbar
//       expand="lg"
//       bg="white"
//       className="shadow-sm py-2"
//     >
//       <Container
//         fluid
//         className="px-3 px-md-4 d-flex align-items-center justify-content-between"
//         style={{ maxWidth: '88%' }}
//       >
//         {/* Logo + Text */}
//         <div className="d-flex align-items-center gap-0">
//           <img
//             src={logo}
//             alt="Vertex Suite Logo"
//             style={{ height: '70px', width: '70px', objectFit: 'contain' }} 
//           />
//           <div className="lh-1">
//             <div style={{ position: 'relative', top: '12px' }}> 
//               <span
//                 className="fw-semi-bold"
//                 style={{
//                   fontSize: '24px',
//                   fontFamily: 'Poppins',
//                   fontWeight: 600,
//                   background: 'linear-gradient(90deg, #317cbeff 0%, #59C0FB 100%)',
//                   WebkitBackgroundClip: 'text',
//                   backgroundClip: 'text',
//                   color: 'transparent',
//                 }}
//               >
//                 Vertex Suite
//               </span>
//             </div>
//             <br />
//             <small
//               style={{
//                 fontSize: '14.5px',
//                 fontFamily: 'Outfit, sans-serif',
//                 fontWeight: '500',
//                 color: '#646363ff',
//                 paddingLeft: 2,
//                 position: 'relative',
//                 top: '-4px'
//               }}
//             >
//               Innovating Workflows
//             </small>
//           </div>
//         </div>

//         {/* Desktop Nav Links */}
//         <Nav 
//           className="d-none d-lg-flex align-items-center gap-3" 
//           style={{ 
//             marginLeft: '-20px' 
//           }}
//         >
//           {navLinks.map((link) =>
//             link.label === 'Products' ? (
//               <ProductsData key="ProductsMenu" />
//             ) : (
//               <Nav.Item key={link.label} className="mx-3">
//                 <Link
//                   to={link.href}
//                   className="text-dark fw-normal text-decoration-none"
//                   style={{ 
//                     fontFamily: "Poppins", 
//                     fontSize: '18px'
//                   }}
//                 >
//                   {link.label}
//                 </Link>
//               </Nav.Item>
//             )
//           )}
//         </Nav>

//         {/* Buttons */}
//         <div className="d-none d-lg-flex gap-3 align-items-center">
//           <button
//             style={{
//               padding: '8px 20px',
//               border: '2px solid transparent',
//               borderRadius: '8px',
//               backgroundImage:
//                 'linear-gradient(#fff, #fff), linear-gradient(to right, #4FC3FF, #2C2C6F)',
//               backgroundOrigin: 'border-box',
//               backgroundClip: 'padding-box, border-box',
//               color: '#1D1D1B',
//               fontFamily: "Poppins",
//               fontSize: '18px',
//               fontWeight: 600,
//               cursor: 'pointer',
//               lineHeight: 1.2,
//             }}
//           >
//             Try Demo
//           </button>
//         </div>

//         {/* Mobile: Menu Button */}
//         <button
//           className="d-lg-none btn btn-outline-secondary"
//           onClick={handleShow}
//           aria-label="Open menu"
//         >
//           ☰
//         </button>

//         {/* Offcanvas Drawer */}
//         <Offcanvas show={showOffcanvas} onHide={handleClose} placement="end">
//           <Offcanvas.Header closeButton>
//             <Offcanvas.Title style={{ fontFamily: "'Outfit', sans-serif" }}>
//               Menu
//             </Offcanvas.Title>
//           </Offcanvas.Header>
//           <Offcanvas.Body className="p-0">
//             {navLinks.map((link) => (
//               <div
//                 key={link.label}
//                 style={{
//                   borderBottom: '1px solid #ddd',
//                   padding: '16px 20px',
//                   fontFamily: "'Outfit', sans-serif",
//                   fontSize: '16px',
//                 }}
//               >
//                 <Link
//                   to={link.href}
//                   className="text-dark text-decoration-none"
//                   onClick={handleClose}
//                   style={{ fontFamily: "'Outfit', sans-serif", fontSize: '16px' }}
//                 >
//                   {link.label}
//                 </Link>
//               </div>
//             ))}
//           </Offcanvas.Body>
//         </Offcanvas>
//       </Container>
//     </Navbar>
//   );
// };

// export default Header;



import React, { useState } from 'react';
import { Container, Navbar, Nav, Offcanvas } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import logo from '../assets/vertexSuiteLogo.png';
import ProductsData from './NavSection_Dropdown/ProductsData';
import IndustriesData from './NavSection_Dropdown/IndustriesData';

const Header = () => {
  const [showOffcanvas, setShowOffcanvas] = useState(false);
  const handleClose = () => setShowOffcanvas(false);
  const handleShow = () => setShowOffcanvas(true);

  const navLinks = [
    // { label: 'Solutions', href: '/#solutions' },
    { label: 'About Us', href: '/aboutus' },
    { label: 'Products', href: '/products' },
    { label: 'Industries', href: '/industries' },
    { label: 'Resources', href: '/resources' },
    { label: 'Pricing', href: '/pricing' }
  ];

  return (
    <Navbar
      expand="lg"
      bg="white"
      className="shadow-sm py-2 position-sticky top-0 z-2 "
    >
      <Container
        fluid
        className="px-2 px-sm-3 px-md-4 d-flex align-items-center justify-content-between"
        style={{ maxWidth: '88%' }}
      >
        {/* Logo + Text */}
        <div className="d-flex align-items-center gap-0">
          <img
            src={logo}
            alt="Vertex Suite Logo"
            className='logo'

          />
          <div className="lh-1">
            <div style={{ position: 'relative', top: '12px' }}>
              <span
                className="logo-h1"
                style={{
                  fontFamily: 'Poppins',
                  fontWeight: 600,
                  background: 'linear-gradient(90deg, #317cbeff 0%, #59C0FB 100%)',
                  WebkitBackgroundClip: 'text',
                  backgroundClip: 'text',
                  color: 'transparent',
                }}
              >
                Vertex Suite
              </span>
            </div>
            <br />
            <small className='logo-h2'
              style={{

                fontFamily: 'Outfit, sans-serif',
                fontWeight: '500',
                color: '#646363ff',
                paddingLeft: 2,
                position: 'relative',
                top: '-4px'
              }}
            >
              Innovating Workflows
            </small>
          </div>
        </div>

        {/* Desktop Nav Links */}
        <Nav
          className="d-none d-lg-flex align-items-center gap-3"
          style={{ marginLeft: '-20px' }}
        >
          {navLinks.map((link) =>
            link.label === 'Products' ? (
              <ProductsData key="ProductsMenu" />
            ) : link.label === 'Industries' ? (
              <IndustriesData key="IndustriesMenu" />
            ) : (
              <Nav.Item key={link.label} className="mx-3">
                <Link
                  to={link.href}
                  className="text-dark fw-normal text-decoration-none"
                  style={{ fontFamily: 'Poppins', fontSize: '18px' }}
                >
                  {link.label}
                </Link>
              </Nav.Item>
            )
          )}
        </Nav>

        {/* Buttons */}
        <div className="d-none d-lg-flex gap-3 align-items-center">
          <button
            style={{
              padding: '8px 20px',
              border: '2px solid transparent',
              borderRadius: '8px',
              backgroundImage:
                'linear-gradient(#fff, #fff), linear-gradient(to right, #4FC3FF, #2C2C6F)',
              backgroundOrigin: 'border-box',
              backgroundClip: 'padding-box, border-box',
              color: '#1D1D1B',
              fontFamily: "Poppins",
              fontSize: '18px',
              fontWeight: 600,
              cursor: 'pointer',
              lineHeight: 1.2,
            }}
          >
            Try Demo
          </button>
        </div>

        {/* Mobile: Menu Button */}
        <button
          className="d-lg-none btn btn-outline-secondary"
          onClick={handleShow}
          aria-label="Open menu"
        >
          ☰
        </button>

        {/* Offcanvas Drawer */}
        <Offcanvas show={showOffcanvas} onHide={handleClose} placement="end">
          <Offcanvas.Header closeButton>
            <Offcanvas.Title style={{ fontFamily: "'Outfit', sans-serif" }}>
              Menu
            </Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body className="p-0">
            {navLinks.map((link) => (
              <div
                key={link.label}
                style={{
                  borderBottom: '1px solid #ddd',
                  padding: '16px 20px',
                  fontFamily: "'Outfit', sans-serif",
                  fontSize: '16px',
                }}
              >
                <Link
                  to={link.href}
                  className="text-dark text-decoration-none"
                  onClick={handleClose}
                  style={{ fontFamily: "'Outfit', sans-serif", fontSize: '16px' }}
                >
                  {link.label}
                </Link>
              </div>
            ))}
          </Offcanvas.Body>
        </Offcanvas>
      </Container>
    </Navbar>
  );
};

export default Header;